import React from "react"

import "./style.scss"

interface ClueCardProps {
  /** Petit intitulé au-dessus de la description (ex. « Indice 3 / 32 ») */
  title: string
  description: string
  /** Joue l'animation de retournement à l'apparition (carte tirée de la pioche) */
  isFlipping?: boolean
  /** Joue l'animation de disparition */
  isLeaving?: boolean
}

/** Carte indice : affiche la description d'un élément, comme une carte retournée de la pioche */
const ClueCard = ({
  title,
  description,
  isFlipping = false,
  isLeaving = false,
}: ClueCardProps) => (
  <div
    className={`dc-clue-card${isFlipping ? " is-flipping" : ""}${
      isLeaving ? " is-leaving" : ""
    }`}
  >
    <p className="dc-clue-card__title">{title}</p>
    <p className="dc-clue-card__description">{description}</p>
  </div>
)

export default ClueCard
